import { render, staticRenderFns } from "./FlatsFilter.vue?vue&type=template&id=175bcf88&scoped=true"
import script from "./FlatsFilter.vue?vue&type=script&lang=js"
export * from "./FlatsFilter.vue?vue&type=script&lang=js"
import style0 from "./FlatsFilter.vue?vue&type=style&index=0&id=175bcf88&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175bcf88",
  null
  
)

export default component.exports